<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-image-input *ngSwitchDefault
                          [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                          [(imageOpacity)]="imageOpacity" (focussed$)="onFocussed($event)"
                          [maxImageSize]="maxImageSize" [allowSvg]="allowSvg"
                          [showImage]="showImage" [showOpacitySlider]="showOpacitySlider"
                          [placeholder]="placeholder" [placeholderImage]="placeholderImage"></fui-edit-image-input>
    <fui-inline-image-input *ngSwitchCase="contextType.INLINE"
                            [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                            [(imageOpacity)]="imageOpacity" (focussed$)="onFocussed($event)"
                            [maxImageSize]="maxImageSize" [allowSvg]="allowSvg"
                            [showImage]="showImage" [showOpacitySlider]="showOpacitySlider"
                            [placeholder]="placeholder" [placeholderImage]="placeholderImage"></fui-inline-image-input>
</ng-container>
